import { cloneDeep } from 'lodash';
import { ref, onBeforeMount, watch } from 'vue';

export default (value) => {
  const isPristine = ref(true);
  const localModelValue = ref({});
  onBeforeMount(() => {
    localModelValue.value = cloneDeep(value);

    const unwatch = watch(localModelValue, () => {
      isPristine.value = false,
      unwatch();
    }, { deep: true });
  });

  return {
    isPristine,
    localModelValue
  }
};
